import EmailCell from './EmailCell'
import EventCell from './EventCell'
import SwitchCell from './SwitchCell'

const useSchema = () => {
  return [
    {
      colId: 'receiveNotification',
      tdStyle: { width: '10%' },
      render: (checked, other) => {
        return <SwitchCell {...other} checked={checked} />
      },
    },
    {
      colId: 'event',
      title: 'systemNotificationsSettings.EVENT',
      isI18n: true,
      tdStyle: { width: '80%' },
      render: (event) => {
        return <EventCell event={event} />
      },
    },
    {
      colId: 'receiveEmail',
      title: 'systemNotificationsSettings.SEND_EMAILS',
      isI18n: true,
      tdStyle: { width: '10%' },
      render: (checked, other) => {
        return <EmailCell {...other} checked={checked} />
      },
    },
  ]
}

export default useSchema
